<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  modelValue: boolean
  title?: string
  message?: string
  confirmText?: string
  cancelText?: string
}>()

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

const closeModal = () => {
  emit('update:modelValue', false)
  emit('cancel')
}

const confirmDelete = () => {
  emit('confirm')
  closeModal()
}

const modalTitle = computed(() => props.title || 'حذف حساب')
const modalMessage = computed(() => props.message || 'آیا از حذف این مورد اطمینان دارید؟')
const modalConfirmText = computed(() => props.confirmText || 'بله حذف شود')
const modalCancelText = computed(() => props.cancelText || 'بازگشت')
</script>

<template>
    <Modal :model-value="props.modelValue" @update:model-value="$emit('update:modelValue', $event)" width="598px"
        background="#FFF" :closable="true">
        <div class="w-full flex flex-col items-center px-2 pt-5 pb-2">
            <h3 class=" font-medium text-[22px] text-[#1b325a] mb-[50px]">{{ modalTitle }}</h3>

            <p class="text-[15px] font-medium text-center text-[#1b325a] leading-6 mb-[50px]">
                {{ modalMessage }}
            </p>

            <div class="flex gap-6 w-full py-3 px-8">
                <Button @click="confirmDelete" :label="modalConfirmText" :isAdmin="true"
                    class="flex-1 h-12! rounded-xl! " />
                <Button @click="closeModal" variant="outline" :label="modalCancelText" :isAdmin="true"
                    class="flex-1  h-12! rounded-xl! border-2 " />

            </div>
        </div>
    </Modal>
</template>

<style scoped>
.close-modal-icon {
    display: none;
}
</style>